import { supabase } from '../../../services/supabaseClient';

// Email login
export async function loginWithEmail(email, password) {
    return supabase.auth.signInWithPassword({
        email,
        password,
    });
}

//Email signup
export async function signupWithEmail(email, password, metadata) {
    return supabase.auth.signUp({
        email,
        password,
        options: {
            data: metadata,
        }
    }
    );
}

//Google login / signup 
export async function loginWithGoogle() {
    return supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
            redirectTo: window.location.origin + '/dashboard',
        },
    });
}

//create user profile
export async function createUserProfile({
    userId,
    email,
    fullName,
    phoneNumber,
}) {
    return await supabase.from('users').upsert([
        {
            user_id: userId,
            email,
            name: fullName,
            phone: phoneNumber,
        },
    ]);
}

/** Sync public.users with profile fields (name, phone, email). */
export async function updateUserProfileRow({ userId, name, phone, email }) {
    const e = String(email || '').trim();
    if (!e) throw new Error('Email is required');
    return supabase
        .from('users')
        .update({
            name: name === '' ? null : String(name).trim(),
            phone: phone == null || String(phone).trim() === '' ? null : String(phone).trim(),
            email: e,
        })
        .eq('user_id', userId);
}

//logout
export async function logout() {
    return await supabase.auth.signOut();
}